import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./SectionLabel";

const traditional = ["Log food", "Log weight", "Log workout", "See numbers", "Figure it out yourself"];
const quantify = ["Track", "Understand", "Adjust", "Repeat"];

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const ProblemSection = () => (
  <section id="how-it-works" className="py-24 md:py-32 lg:py-40" data-testid="problem-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <SectionLabel number={1} title="The Problem" />

      <motion.h2
        {...fadeUp}
        className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight font-medium text-[#171717] max-w-[820px]"
      >
        Most health apps help you track.
        <br className="hidden md:block" /> Very few help you understand.
      </motion.h2>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-6 items-center">
        <motion.div {...fadeUp} className="border border-[#171717]/10 rounded-2xl p-8 md:p-10 bg-white/40">
          <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#171717]/40 mb-6">
            The usual way
          </p>
          <ul className="space-y-4">
            {traditional.map((item, i) => (
              <li key={item} className="flex items-center gap-3 text-lg text-[#171717]/60">
                <span className="text-[#171717]/25 font-mono text-sm">0{i + 1}</span>
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.12 }}
          className="rounded-2xl p-8 md:p-10 bg-[#171717] text-[#F8F7F3]"
          data-testid="quantify-loop-card"
        >
          <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#F8F7F3]/40 mb-6">
            The Quantify way
          </p>
          <div className="flex flex-wrap items-center gap-3 text-lg md:text-xl font-medium">
            {quantify.map((item, i) => (
              <span key={item} className="flex items-center gap-3">
                <span className={i === 1 ? "text-[#B8D99A]" : ""}>{item}</span>
                {i < quantify.length - 1 && <ArrowRight size={18} className="text-[#F8F7F3]/30" />}
              </span>
            ))}
          </div>
        </motion.div>
      </div>

      <motion.p
        {...fadeUp}
        transition={{ ...fadeUp.transition, delay: 0.2 }}
        className="mt-14 text-xl md:text-2xl text-[#171717]/50 italic max-w-[560px]"
      >
        “I already have the data. I just don&rsquo;t know what it means yet.”
      </motion.p>
    </div>
  </section>
);
